import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { QrCodeObjectInterface } from "../../../../../helpers/qrCodeFormater";
import { setVerifyCommandProductsListByScan } from "../../../../../redux/reducer/picking.reducer";

const headerScrollOffset = 100;

function useVerifyCommandProductsConfig({
  qrCodeParams,
}: {
  qrCodeParams: QrCodeObjectInterface | null;
}) {
  const dispatch = useAppDispatch();

  const {
    picking: {
      verifyCommand: { verificationZone },
      verifyCommandProducts: {
        data: verifyCommandProductsData,
        isLoading: isLoadingVerifyCommandProducts,
      },
    },
  } = useAppSelector((state) => ({
    picking: state.picking,
  }));

  const searchedProductSerialNumber = qrCodeParams?.serialNumber ?? "";

  const handleScrollToItem = useCallback((itemId: string) => {
    const tableElementIdTop = document
      .getElementById(itemId)
      ?.getBoundingClientRect().top;
    const bodyRectTop = document.body.getBoundingClientRect().top;

    if (!tableElementIdTop) {
      return;
    }

    window.scrollTo({
      behavior: "smooth",
      top: tableElementIdTop - bodyRectTop - headerScrollOffset,
    });
  }, []);

  useEffect(() => {
    if (searchedProductSerialNumber) {
      handleScrollToItem(searchedProductSerialNumber);
    }
  }, [handleScrollToItem, searchedProductSerialNumber]);

  useEffect(() => {
    if (!qrCodeParams?.isQrCode) {
      return;
    }

    const hasMatchedProduct = verifyCommandProductsData.list?.some(
      (product) =>
        !product.isValidate &&
        product.cantitatePick === product.cantitate &&
        product.sn === qrCodeParams.serialNumber &&
        product.lot === qrCodeParams.lot &&
        product.data_exp === qrCodeParams.expirationDate,
    );

    if (!hasMatchedProduct) {
      return;
    }

    dispatch(
      setVerifyCommandProductsListByScan({
        serialNumber: qrCodeParams.serialNumber,
        lot: qrCodeParams.lot,
        expirationDate: qrCodeParams.expirationDate,
        changes: { isValidate: true },
      }),
    );
  }, [
    dispatch,
    qrCodeParams?.serialNumber,
    qrCodeParams?.isQrCode,
    qrCodeParams?.lot,
    qrCodeParams?.expirationDate,
    verifyCommandProductsData.list,
  ]);

  return {
    verifyCommandProductsData,
    isLoadingVerifyCommandProducts,
    verificationZone,
  };
}

export default useVerifyCommandProductsConfig;
